// Single source of truth for SFLCM contact details, address, hours, and
// social handles. Import from here everywhere — never hardcode in pages or
// components. If any of these change, update this file only.

export const PHONE_DISPLAY = '(954) 842-2652';
export const PHONE_TEL = 'tel:9548422652';
export const SMS_HREF = 'sms:+19548422652?&body=Hi%2C%20I%27d%20like%20info%20about%20music%20lessons.';

// Build an sms: link with a pre-filled body. Same shape as SMS_HREF above:
// `?&body=` works on both iOS (which wants `&`) and Android (which wants `?`).
export const SMS_URI = SMS_HREF.split('?')[0];
const encodeBody = (text) => encodeURIComponent(text).replace(/'/g, '%27');
export const smsHref = (body) => `${SMS_URI}?&body=${encodeBody(body)}`;
export const mailtoHref = (subject, body) =>
  `mailto:${EMAIL}?subject=${encodeBody(subject)}${body ? `&body=${encodeBody(body)}` : ''}`;

// Pages whose shared Text links (top bar, footer) should open with a
// page-specific message instead of the lessons one.
export const ROOM_RENTAL_SMS_BODY = "Hi, I'd like to rent a room at SFLCM. Space and date/time: ";
const PAGE_SMS_BODY = { '/room-rentals': ROOM_RENTAL_SMS_BODY };
/** The shared Text link for a route: SMS_HREF unless the page has its own message. */
export const smsHrefForPath = (pathname = '') => {
  const body = PAGE_SMS_BODY[String(pathname).replace(/\/+$/, '') || '/'];
  return body ? smsHref(body) : SMS_HREF;
};

export const EMAIL = 'info@sflcm.com';

export const ADDRESS_LINE_1 = '1940 Harrison St, Suite 100';
export const ADDRESS_LINE_2 = 'Hollywood, FL 33020';
export const ADDRESS_FULL = `${ADDRESS_LINE_1}, ${ADDRESS_LINE_2}`;

export const HOURS_WEEKDAY = 'Mon–Fri: 2:00 PM – 9:00 PM';
export const HOURS_SATURDAY = 'Sat: 10:00 AM – 5:00 PM';

export const SOCIAL_INSTAGRAM = '@sflcm';
export const SOCIAL_FACEBOOK = '@sflconservatory';

// Full social profile map. Use this everywhere — SOCIAL_INSTAGRAM/FACEBOOK
// above are kept only for backwards-compat handle display.
export const SOCIAL = {
  instagram: {
    url: 'https://instagram.com/sflcm',
    label: 'Instagram',
    icon: 'instagram',
  },
  facebook: {
    url: 'https://facebook.com/sflconservatory',
    label: 'Facebook',
    icon: 'facebook',
  },
  x: {
    url: 'https://x.com/sflcm',
    label: 'X (Twitter)',
    icon: 'x',
  },
  linkedin: {
    url: 'https://www.linkedin.com/company/south-florida-conservatory-of-music',
    label: 'LinkedIn',
    icon: 'linkedin',
  },
  youtube: {
    url: 'https://www.youtube.com/@sflcm',
    label: 'YouTube',
    icon: 'youtube',
  },
};
